import React, { useState } from "react";
import styled from "styled-components";
import {
    Button,
    Text,
    StandardModal,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalSection
} from "src/components";

const StyledText = styled(Text)`
    text-align: left;
    color: #000000;
    max-width: 44.375rem;
`;

const CancellationTermsModal = (props) => {
    const [ open, setOpen ] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <React.Fragment>
            <Button width="17.6875rem"
                backgroundColor="#000000"
                color="#fff"
                height="2.345625rem"
                size="0.875rem"
                marginTop="0.5rem"
                style={{ borderRadius: 7 }}
                onClick={handleOpen}
            >
                Subscription & Cancellation Terms
            </Button>
            <StandardModal
                open={open}
                onClose={handleClose}
                widthMode="wide"
                title="Subscription & Cancellation Terms"
                footer={(
                    <StandardModalActionGroup $pushRight>
                        <StandardModalActionButton
                            $variant="primary"
                            onClick={handleClose}
                        >
                            Close
                        </StandardModalActionButton>
                    </StandardModalActionGroup>
                )}
            >
                <StandardModalSection>
                    <StyledText size="1.25rem">
                        Subscription Terms:
                    </StyledText>

                    <StyledText>                    
                        Your subscription begins as soon as your initial payment is processed. Your subscription will automatically renew annually or 
                        monthly without notice until you cancel. You authorise us to store your payment method(s) and to automatically charge your 
                        payment method(s) annually or monthly until you cancel.
                    </StyledText>
                    <StyledText>
                        We will automatically charge you the then-current rate for your plan, plus applicable taxes (such as GST if the rate does not 
                        include it), every month of your annual contract until you cancel. We may change your plan’s rate each annual renewal term, and 
                        we will notify you of any rate change with the option to cancel. If the applicable GST rate (or other included tax or duty) changes 
                        during your one-year term, we will accordingly adjust the tax-inclusive price for your plan mid-term on your next billing date.
                    </StyledText>
                    <StyledText>
                        If your primary payment method fails, you authorise us to charge any other payment method in your account. If you have not provided 
                        us a backup payment method(s) and you fail to provide payment, or if all payment methods in your account fail, we may suspend your 
                        subscription. You can edit your payment information any time in your Me Account page.
                    </StyledText>
                    <StyledText>
                        For European Economic Area customers, your bank may require you to authenticate your initial purchase using a password, a one-time code 
                        sent to your mobile number, or biometric recognition. When you authenticate, you also authorise us to charge your payment method for your 
                        additional purchases without providing us further payment information or other instructions (i.e., we will initiate future payments independently). 
                        Such additional purchases may occur when we automatically charge your payment method in connection with a recurring subscription or when you add or 
                        change licenses or products. 
                    </StyledText>

                    <StyledText margin="2rem 0 2.5rem 0" size="1.25rem">Cancellation Terms:</StyledText>
                    <StyledText>
                        You can cancel your subscription any time via your Me account page or by contacting Customer Support. Should you cancel your
                        monthly subscription, you’ll be charged a lump sum amount of 50% of your remaining 12 month contract obligation and your service will 
                        continue until the end of that month’s billing period.
                    </StyledText>

                </StandardModalSection>
            </StandardModal>
        </React.Fragment>
    );
};

export default CancellationTermsModal;
